import {http} from "../config/Constantes";

export default class CentroCustoDebitoService {
    constructor() {}

    list() {
        return http.get("/centrocustodebito");
    }
}
